export default {
    namespaced: true,

    state: {
        // Филиалы
        branches: [
            { id: 1, label: "Щербинка" },
            { id: 2, label: "Бутово" },
            { id: 3, label: "Ясенево" },
            { id: 4, label: "Коммунарка" },
            { id: 5, label: "Подольск" },
        ],

        // Смена
        shifts: [
            { id: 1, label: "Дневная" },
            { id: 2, label: "Ночная" },
            { id: 3, label: "Расчетная" }
        ],

        // Статусы сотрудников
        employeesStatuses: [
            { label: "Отстранен от работы", id: 1 },
            { label: "Декретный отпуск", id: 2 },
            { label: "Резерв из ушедших", id: 3 },
            { label: "Работает", id: 4 },
            { label: "Больничный", id: 5 },
            { label: "Отпуск", id: 6 },
            { label: "Уволен", id: 7 },
            { label: "Стажировка", id: 8 }
        ],

        // Характеристики
        employeesCharacteristics: [
            { label: "Кандидат на повышение", id: 1 },
            { label: "Стажировка", id: 2 },
            { label: "Есть замечания", id: 3 },
            { label: "Нужно заменить", id: 4 },
            { label: "Хороший сотрудник", id: 5 }
        ],

        // Гражданство
        citizenships: [
            { label: "Россия", id: 1 },
            { label: "Германия", id: 2 },
            { label: "Россия", id: 3 },
            { label: "Германия", id: 4 },
        ],

        // Правовые статусы
        legalStatuses: [
            { label: "Постоянно проживающий", id: 1 },
            { label: "Временно пребывающий", id: 2 },
            { label: "Временно пребывающий", id: 3 },
        ],

        // Заполненность анкеты
        worksheetCompletions: [
            { label: "Заполнено", id: 1 },
            { label: "Частично заполнено", id: 2 },
            { label: "Не заполнено", id: 3 },
        ],

        // Должности
        positions: [
            { id: 1, label: "Повар-сушист" },
            { id: 2, label: "Повар-пиццмейкер" },
            { id: 3, label: "Администратор филиала" },
            { id: 4, label: "Водители" },
            { id: 5, label: "Официант" },
            { id: 6, label: "Остальные" },
            { id: 7, label: "Горячий цех" },
            { id: 8, label: "Клининг-мастер" }
        ],

        // Разряды
        ranks: [
            { id: 1, label: 0 },
            { id: 2, label: 1 },
            { id: 3, label: 2 },
        ],

        // Рабочие графики
        workingSchedules: [
            { id: 1, label: "2/2" },
            { id: 2, label: "4/3" },
            { id: 3, label: "5/2" },
            { id: 4, label: "6/1" },
        ],

        // Депозит
        deposits: [
            { id: 1, label: "Без депозита" },
            { id: 2, label: "Внесен частично" },
            { id: 3, label: "Внесен" },
            { id: 4, label: "Не внесен" },
            { id: 5, label: "Внесен излишне" },
            { id: 6, label: "Выплачен излишне" }
        ],

        // Языки
        languages: [
            { id: 1, label: "Азербайджанский" },
            { id: 2, label: "Английский" },
            { id: 3, label: "Болгарский" },
            { id: 4, label: "Венгерский" }
        ],

        // Программы
        programs: [
            { id: 1, label: "1C" },
            { id: 2, label: "cmd" },
            { id: 3, label: "Excel" },
            { id: 4, label: "Word" }
        ],

        // Специальности
        specialties: [
            { id: 1, label: "Младший", positionId: 3 },
            { id: 2, label: "Основной", positionId: 3 },
            { id: 3, label: "Повар", positionId: 7 },
            { id: 4, label: "Еще один повар", positionId: 7 },
            { id: 5, label: "Уборка", positionId: 8 }
        ],

        // Возраст
        ages: [
            { id: 1, label: "Младше 21" },
            { id: 2, label: "21-30" },
            { id: 3, label: "31-40" },
            { id: 4, label: "41-50" }
        ]
    },

    getters: {
        branches (state) {
            return state.branches;
        },

        shifts (state) {
            return state.shifts;
        },

        employeesStatuses (state) {
            return state.employeesStatuses;
        },

        employeesCharacteristics (state) {
            return state.employeesCharacteristics;
        },

        citizenships (state) {
            return state.citizenships;
        },

        legalStatuses (state) {
            return state.legalStatuses;
        },

        worksheetCompletions (state) {
            return state.worksheetCompletions;
        },

        positions (state) {
            return state.positions;
        },

        ranks (state) {
            return state.ranks;
        },

        workingSchedules (state) {
            return state.workingSchedules;
        },

        deposits (state) {
            return state.deposits;
        },

        languages (state) {
            return state.languages;
        },

        programs (state) {
            return state.programs;
        },

        specialties (state) {
            return state.specialties;
        },

        ages (state) {
            return state.ages;
        },
    }
};